import PLPState from "./plp_state.js";
import fixTextBlockHeights from "./ui/plp_image_height_fix.js";
import * as searchHelper from "../helpers/search-helper";
import productType from "./ui/productType_filter.js"
import * as activityLogger from "../helpers/activity-logger";

$(function () {
    if ($(".plp-container").length) {
        const SCROLL_MORE_HEIGHT = 3.5;
        let plpState = PLPState.getInstance();
        let loading = false;
        let plpBase = $(".plp-container").data("plp");

        // When user selects a filter => add new value to the state
        $(document).on(
            "change",
            '.multi-select.select .list .list-item input[type="checkbox"]',
            function (e) {
                let filterName = $(this).data("filtertype");
                let value = $(this).attr("id");
                if (this.checked) {
                    plpState.add(filterName, value);
                } else {
                    plpState.remove(filterName, value);
                }
            }
        );

        $(document).on(
            "mouseup",
            '.multi-select.select .list .list-item ',
            function (e) {
                reloadMobileFilterCount();
            }
        );

        // When user clicks on a selected pill => remove it from state and reload PLP
        $(document).on("click", ".pillWrapper .pill:not(.search-pill):not(.clear)", function () {
            const key = $(this).data("key");
            const value = String($(this).data("value"));
            plpState.remove(key, value);
            reloadPLP();
        });        

        // When user clicks on the current selected search pill, clear the search option
        $(document).on("click", "section.search .pillWrapper .search-pill", function (e) {
                plpState.remove("search");
                setSearchSource(null);
                reloadPLP();
            }
        );

        // When user clicks on selected pill clear => remove all selected from state and reload PLP
        $(document).on("click", ".pill.clear", function () {
            $(".pillWrapper button.pill").each(function () {
                plpState.remove($(this).data("key"));
            });
            reloadPLP();
        });

        // When user clicks filter select button => filters and products
        $(document).on(
            "click",
            ".filter-container .multi-select .select-button",
            function (e) {
                if (Object.keys(plpState.state).length > 0) {
                    activityLogger.logActivity('Filter', plpBase + '-plp', plpState.state);
                }
                reloadPLP();
            }
        );

        // When user clicks off a filter => reload the filters and products
        $(document).on(
            "closed",
            ".filter-container .multi-select",
            function (e) {
                if(isDesktopFilters()){
                    if ($(this).data("has-changed") === true) {
                        if (Object.keys(plpState.state).length > 0) {
                            activityLogger.logActivity('Filter', plpBase + '-plp', plpState.state);
                        }
                        reloadPLP();
                    }
                } else {
                    reloadMobileFilterCount();
                }
            }
        );

        // When user clicks on sort => add it to the filter
        $(document).on("change", ".sortBy select", function (e) {
            plpState.remove("sortby");
            plpState.add("sortby", this.value);
            reloadPLP();
        });


        // When user hits enter on search box => add search and filter
        $(document).on("click", ".search .search-button", function (e) {
            const plpSearchBox = $("#plp-search");
            const mappedSearchString = searchHelper.mapTerms(plpSearchBox.val());
            plpSearchBox.val(mappedSearchString);
            plpState.add("search", mappedSearchString);
            setSearchSource('PLP');
            reloadPLP();
        });

        // When user hits enter on search box => add search and filter
        $(document).on("keydown", "#plp-search", function (e) {
            if (e.which == 13) {
                plpState.remove("search");
                const plpSearchBox = $("#plp-search");
                const mappedSearchString = searchHelper.mapTerms(plpSearchBox.val());
                plpSearchBox.val(mappedSearchString);
                plpState.add("search", mappedSearchString);
                setSearchSource('PLP');
                reloadPLP();
            }
        });

        // When user selects a different duty type toggle => reload the filters
        $(document).on("change", 'input[name="dutySelector_mobile"], input[name="dutySelector_desktop"]', function (e) {
            plpState.remove("duty");
            plpState.add("duty", $(this).val());
            if(e.currentTarget.id === 'delivery_button_mobile' || e.currentTarget.id === 'delivery_button_desktop'){
                plpState.remove("caseprice");
            }else{
                plpState.remove('bottleprice')
            }
            reloadPLP();

            activityLogger.logActivity(
                "Dutytoggle: change",
                $("body").data("route"),
                { changeTo: $(this).val() }
            );
        });

        function loadProductsAjax(){
            var numProducts = $(".product_wrapper").children().length;

            if (
                $(window).scrollTop() +
                    SCROLL_MORE_HEIGHT * window.innerHeight >
                    $(document).height() &&
                $(".product_wrapper .no-more-products").length === 0 &&
                numProducts > 0
            ) {
                if (loading === false) {
                    loading = true;
                    axios({
                        method: "POST",
                        url: `/${plpBase}/load-products-ajax`,
                        data: {
                            itemcount: $(".product_wrapper .product").length,
                            filters: plpState.state,
                        },
                    }).then(function (response) {
                        if (response.data.success === false) {
                            if (
                                $(".product_wrapper .no-more-products")
                                    .length === 0
                            ) {
                                $(".product_wrapper").append(getEndOfProductsTxt());
                            }
                            $(".plp.loader-wrapper").hide();
                        } else {
                            $(".product_wrapper").append(response.data.html);
                        }

                        loading = false;

                        fixTextBlockHeights();
                    });
                }
            }
        }

        // Load new stock when we get to the bottom
        $(window).scroll(function () {
            loadProductsAjax();
        });
        loadProductsAjax();

        function getEndOfProductsTxt() {

            let $noMoreProducts = $(
                "<p class='no-more-products'>No more products</p>"
            );
            if ($(".product_wrapper .product").length === 0) {
                let $clearFilters = $('<button class="inverted pill clear btn new-btn" style="width: 200px;display: block;margin: auto;margin-top: 10px;"><span>Clear filters</span></button>');
                $noMoreProducts.append($clearFilters);
            }
            return $noMoreProducts;
        }

        function refreshMarketingData(params) {

            axios.get(`/${plpBase}/get-marketing-data`, { params })
            .then((response) => {
                
                let data = response.data;

                if (data.html !== "") {
                    const newHtml = data.html.trim();
                    const $old = $(".top-container");

                    if ($old.text().trim() !== $(newHtml).text().trim()) {
                        console.log("Updating marketing data");
                        $old.fadeOut(300, function() {
                            const $new = $(newHtml).hide();
                            $(this).replaceWith($new);
                            $new.fadeIn(300);
                        });
                    }
                }
                
                // title
                if (data.title && document.title !== data.title) {
                    document.title = data.title;
                    $("meta[name='twitter:title']").attr("value", data.title);
                    $("meta[property='og:title']").attr("content", data.title);
            
                    $("meta[property='twitter:url']").attr("content", window.location.href);
                    $("meta[property='og:url']").attr("content", window.location.href);
                }
            
                // tag
                if (data.body) {
                    $("meta[name='description']").attr("content", data.body);
                    $("meta[name='twitter:description']").attr("value", data.body);
                    $("meta[property='og:description']").attr("content", data.body);
                }

                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        // Function to reload the filters and products
        function reloadPLP() {

            $(".plp-page__container").empty();
            $(".plp.loader-wrapper").show();
            $('body').removeClass('no-scroll');
            
            loading = true;

            // Update the top URL
            axios({
                method: "POST",
                url: `/${plpBase}/load-product-listing-page-url-ajax`,
                data: { filters: plpState.state }
            }).then(function (response) {
                history.pushState({}, "", response.data.url);
            });

            // Update the filters and products
            axios({
                method: "POST",
                url: `/${plpBase}/load-product-listing-page-ajax`,
                data: { filters: plpState.state, searchSource: getSearchSource() },
            }).then(function (response) {
                $(".plp-page__container").append(response.data.html);

                $(".list input:checked").each(function () {
                    $(this)
                        .closest(".list")
                        .prev(".list-title")
                        .addClass("active");
                });

                if ($(".product_wrapper").children().length === 0) {
                    $(".product_wrapper").empty();
                    $(".product_wrapper").append(getEndOfProductsTxt());
                    $(".plp.loader-wrapper").hide();
                }

                // Reload breadcrumb div
                $("#plp-breadcrumb").load(" #plp-breadcrumb");

                loading = false;

                fixTextBlockHeights();

            });

            if(plpBase !== 'search-results'){
                refreshMarketingData(plpState.state);
            }
            
        }

        function getSearchSource() {
            try {
                const searchSourceJsonString = $('script#searchSource').text();
                if (searchSourceJsonString) {
                    return JSON.parse(searchSourceJsonString).searchSource;
                }
            } catch (e) {
                console.error("Failed to get search source", e);
            }

            return null;
        }

        function setSearchSource(source) {
            try {
                const searchSourceObj = {"searchSource": source};
                const searchSourceJsonString = JSON.stringify(searchSourceObj);
                $('script#searchSource').text(searchSourceJsonString);
            } catch (e) {
                console.error("Failed to set search source", e);
            }
        }

        $(document).on("change", 'select[name="category"]', {route: plpBase, loadPLP: reloadPLP}, function(event) {
            productType(event);
        });


        $(document).on("change", 'select[name="livetrade"]', function (e) {
            plpState.remove('livetrade');
            plpState.add('livetrade', $(this).val());
            reloadPLP();
        });

        $(document).on("click", '.applyFilters', function (e) {
            $('.filters_overlay').removeClass('active');
            $('body').removeClass('no-scroll');
            reloadPLP();
        });

        let productCountController = null; 

        function getProductCount(callback) {

            // prevent incorrect order of requests
            if (productCountController) {
                productCountController.abort();
            }
            productCountController = new AbortController();
            const { signal } = productCountController;

            axios({
                method: "POST",
                url: `/fine-wine/get-product-count-ajax`,
                data: { filters: plpState.state },
                signal: signal,
            }).then(response => {
                callback(response.data.count);
            }).catch(error => {
                if (axios.isCancel(error)) {
                    console.log("Request canceled:", error.message);
                } else {
                    console.error("Error fetching product count:", error);
                }
            });
        }

        $(document).on("click",".mobile.filterControls .showMobileFilterBtn", function (e) {
            e.preventDefault();
            $('.filters_overlay').addClass('active');
            $('body').addClass('no-scroll');
            $('#jsd-widget').hide();
            $('#scrollToTopBtn').hide();
        });
    
        $(document).on("click",".filters_overlay .closeOverlay", function (e) {
            $('.filters_overlay').removeClass('active');
            $('body').removeClass('no-scroll');
        });
        
        function isDesktopFilters(){
            return !$(".mobile.filters_overlay.active").hasClass('active');
        }

        function reloadMobileFilterCount(){
            if(!isDesktopFilters()){
                getProductCount(function(count){
                    $('.mobile .applyFilters').html(`See Products (${count})`);
                });
            }
        }

        
    }

    function hideMobileFiltersOnResize(){
        let $mobileOverlay = $(".mobile.filters_overlay");
        if(!$mobileOverlay.is(":visible") && $mobileOverlay.hasClass('active')){
            $('body').removeClass('no-scroll');
            $mobileOverlay.removeClass('active');
        }
    }

    $(window).on("resize", function () {
        hideMobileFiltersOnResize();
        fixTextBlockHeights();
    });
    fixTextBlockHeights();
   
    $(document).on("click",".read_more", (event) => {
        $(event.currentTarget).closest('.description').addClass('expand');
        return false;
    });

    $(document).on("click",".read_less", (event) => {
        $(event.currentTarget).closest('.description').removeClass('expand');
        return false;
    });
    
});
